module KendoWidgets
{
	export class PDFViewerOptions implements kendo.ui.PDFViewerOptions
	{
		width?: number | string;
		height?: number | string;
		autoPrint?: boolean;
		base64Bytes?: string;
		windowTitle?: string;
		orientation?: PdfViewerOrientationEnum;
		fileName?: string;
		openChangeCalculator?: number;
		customToolbarItems?: PdfViewerToolbarItem[];

		mailClick?: (e: PdfViewerMailClickEvent) => void;
		autoMail?: boolean;
		mailAddress?: string;
		mailDestinationName?: string;
		languageSettings?: PdfViewerLanguageSettings;
		contactToIdList?: number[] | undefined;
	}

	export class PDFViewer extends kendo.ui.PDFViewer implements KendoWidget
	{
		public controlType(): ControlTypeEnum { return ControlTypeEnum.PDFViewer; }
		private _base64Bytes?: string;

		constructor(element: Element, options?: KendoWidgets.PDFViewerOptions)
		{
			if (options == null)
				options = new KendoWidgets.PDFViewerOptions();

			if (options.width == null) options.width = "100%";
			if (options.height == null) options.height = "100%";
			if (options.windowTitle == null) options.windowTitle = "Anteprima del file";
			if (options.autoPrint == null) options.autoPrint = true;
			if (options.orientation == null) options.orientation = PdfViewerOrientationEnum.Vertical;
			if (options.autoMail == null) options.autoMail = true;

			(options as any).scale = 1.45;

			//#region Messages
			(options as kendo.ui.PDFViewerOptions).messages =
				{
					toolbar: { pager: { page: "pagina", pages: "pagine"} }
				};
			//#endregion

			//#region File name
			if (options.fileName != null)
			{
				let fileName = options.fileName.replace(".pdf", "");
				(options as any).messages = { toolbar: { pager: { page: "pagina", pages: "pagine" } }, defaultFileName: fileName };
			}
			//#endregion

			if (options.base64Bytes != null)
				(options as kendo.ui.PDFViewerOptions).pdfjsProcessing = { file: { data: options.base64Bytes } };

			super(element, options);

			this._base64Bytes = options.base64Bytes;
		}

		changeOptions(options: KendoWidgets.PDFViewerOptions)
		{
			this._base64Bytes = options.base64Bytes;
			(this.options as KendoWidgets.PDFViewerOptions).base64Bytes = options.base64Bytes;
			(this.options as any).callBackIfUpdateBytes(this.element.attr("id"),
				{
					width: (options != null && options.width != null) ? options.width : (this.options as KendoWidgets.PDFViewerOptions).width,
					height: (options != null && options.height != null) ? options.height : (this.options as KendoWidgets.PDFViewerOptions).height,
					fileName: (options != null && options.fileName != null) ? options.fileName : (this.options as KendoWidgets.PDFViewerOptions).fileName,
					base64Bytes: options.base64Bytes,
					windowTitle: (options != null && options.windowTitle != null) ? options.windowTitle : (this.options as KendoWidgets.PDFViewerOptions).windowTitle,
					autoPrint: (options != null && options.autoPrint != null) ? options.autoPrint : (this.options as KendoWidgets.PDFViewerOptions).autoPrint,
					openChangeCalculator: (options != null && options.openChangeCalculator != null) ? options.openChangeCalculator : (this.options as KendoWidgets.PDFViewerOptions).openChangeCalculator,
					mailClick: (options != null && options.mailClick != null) ? options.mailClick : (this.options as KendoWidgets.PDFViewerOptions).mailClick,
					languageSettings: (options != null && options.languageSettings != null) ? options.languageSettings : (this.options as KendoWidgets.PDFViewerOptions).languageSettings,
					customToolbarItems: (options != null && options.customToolbarItems != null) ? options.customToolbarItems : (this.options as KendoWidgets.PDFViewerOptions).customToolbarItems,
					orientation: (options != null && options.orientation != null) ? options.orientation : (this.options as KendoWidgets.PDFViewerOptions).orientation,
					autoMail: (options != null && options.autoMail != null) ? options.autoMail : (this.options as KendoWidgets.PDFViewerOptions).autoMail,
					mailAddress: (options != null && options.mailAddress != null) ? options.mailAddress : (this.options as KendoWidgets.PDFViewerOptions).mailAddress,
					mailDestinationName: (options != null && options.mailDestinationName != null) ? options.mailDestinationName : (this.options as KendoWidgets.PDFViewerOptions).mailDestinationName,
				});
		}

		bytes(base64Bytes?: string)
		{
			if (base64Bytes != null)
				this.changeOptions({ base64Bytes: base64Bytes });

			return this._base64Bytes;
		}

		getLanguageItem()
		{
			let languageId = $("#" + this.element.attr("id").replace("divPdfViewer_", "") + "_selectLanguagePdfPreview").find("option:selected").val();
			let languageText = $("#" + this.element.attr("id").replace("divPdfViewer_", "") + "_selectLanguagePdfPreview").find("option:selected").text();
			return { value: String(languageId), text: languageText };
		}

		clear()
		{
			this.destroy();
			$("#divPdfViewer_" + this.element.attr("id").replace("divPdfViewer_", "").replace("#", "")).remove();
		}
	}

	PDFViewer.fn = PDFViewer.prototype;
	PDFViewer.fn.options = $.extend(true, {}, kendo.ui.PDFViewer.fn.options);
	PDFViewer.fn.options.name = "PDFViewer";
	kendo.ui.plugin(PDFViewer);

	export class PdfViewerMailClickEvent
	{
		public base64string?: string;
	}

	export class PdfViewerLanguageClickEvent
	{
		public text: string;
		public value: string;
		public base64string?: string;
	}

	class PdfViewerToolbarItem
	{
		icon?: string;
		text?: string;
		click?: (e: PdfViewerToolbarClickEvent) => void;
	}

	class PdfViewerToolbarClickEvent
	{
		
	}

	export class PdfViewerLanguageSettings
	{
		languageClick?: (e: PdfViewerLanguageClickEvent) => void;
		languages?: KendoWidgets.DropDownListItem[];
		selectedLanguageId?: number;
	}

	export enum PdfViewerOrientationEnum
	{
		Horizontal,
		Vertical
	}
}

interface JQuery
{
	kendoPDFViewer(options?: KendoWidgets.PDFViewerOptions): JQuery;
}